/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { httpsCallable } from 'firebase/functions'

import { functions } from '@/firebase'

const createCompletion = httpsCallable(functions, 'createChatCompletion')

export const handleGenerateMultipleChoiceOptions = async (
  question: string,
  isMultiSelect = false,
): Promise<{
  choices?: {
    option: string
    value: string
  }[]
  answers?: string[]
  error?: boolean
  message?: string
}> => {
  const ai_data = {
    chat: {
      model: 'gpt-4o-mini',
      temperature: 1.2,
      messages: [
        {
          role: 'user',
          content: [
            {
              type: 'text',
              text: `
           You will generate multiple choice options for the following question:
           ${question}

           Ensure that the options are reasonable and relevant to the question.

           ## Mutliple Choice question type:
           ${
             isMultiSelect
               ? 'This is a multi-select question: you may return multiple options in the answers array.'
               : 'This is a single-select question: you may return only one option in the answers array.'
           }

           ## Respond with the following JSON  format:
           {
              choices:[
                {
                  option: 'A',
                  value: 'Option A'
                },{
                  option: 'B',
                  value: 'Option B'
                },{
                  option:  'C',
                  value: 'Option C'
                }
              ],
              answers: [ 'A'] // for multi-select, you may add various options; by default, its single-select

            }
              Randomize the correct answer. Create 4 options.
          `,
            },
          ],
        },
      ],
    },
    response_format: {
      type: 'json_object',
    },
  }

  try {
    const { data } = (await createCompletion(ai_data)) as { data: { response: { content: string } } }

    const cleanResponse = data?.response?.content
      .replace(/```json\n?/g, '')
      .replace(/```\n?/g, '')
      .trim()

    const response = JSON.parse(cleanResponse) as {
      answers: string[]
      choices: {
        option: string
        value: string
      }[]
    }

    return {
      ...response,
      error: false,
    }
  } catch (error) {
    console.error('Error generating multiple choice options:', error)

    if (error instanceof Error) {
      return {
        error: true,
        message: error.message,
      }
    }

    return {
      error: true,
      message: 'Error generating multiple choice options',
    }
  }
}

const replaceExistingOption = async (
  options: {
    value: string
    option: string
  }[],
  optionToReplace: {
    value: string
    option: string
  },
) => {
  const ai_data = {
    chat: {
      model: 'gpt-4o-mini',
      temperature: 1.2,
      messages: [
        {
          role: 'user',
          content: [
            {
              type: 'text',
              text: `

           You will replace the following option from a multiple choice question:
           ${optionToReplace}

            The current options are:
            ${JSON.stringify(options)}

           Ensure that the new option is reasonable and relevant to the question.

           Respond with the following JSON  format:
           {
            value: 'New Option'
           }

            Ensure that the option letter remains the same.
          `,
            },
          ],
        },
      ],
    },
    response_format: {
      type: 'json_object',
    },
  }

  try {
    const { data } = (await createCompletion(ai_data)) as { data: { response: { content: string } } }

    const cleanResponse = data?.response?.content
      .replace(/```json\n?/g, '')
      .replace(/```\n?/g, '')
      .trim()

    return JSON.parse(cleanResponse)
  } catch (error) {
    console.error('Error replacing option:', error)
    throw new Error(error)
  }
}

export { replaceExistingOption }
